import { Converter } from '../types/converter';

export const prefixesConverter: Converter = {
  id: 'prefixes',
  name: 'Prefixes Converter',
  icon: 'Type',
  categories: ['common'],
  units: [
    // SI prefixes (large)
    { name: 'Yotta', symbol: 'Y', factor: 1e24 },
    { name: 'Zetta', symbol: 'Z', factor: 1e21 },
    { name: 'Exa', symbol: 'E', factor: 1e18 },
    { name: 'Peta', symbol: 'P', factor: 1e15 },
    { name: 'Tera', symbol: 'T', factor: 1e12 },
    { name: 'Giga', symbol: 'G', factor: 1e9 },
    { name: 'Mega', symbol: 'M', factor: 1e6 },
    { name: 'Kilo', symbol: 'k', factor: 1e3 },
    { name: 'Hecto', symbol: 'h', factor: 1e2 },
    { name: 'Deka', symbol: 'da', factor: 1e1 },
    
    // Base unit
    { name: 'None', symbol: '', factor: 1 },
    
    // SI prefixes (small)
    { name: 'Deci', symbol: 'd', factor: 1e-1 },
    { name: 'Centi', symbol: 'c', factor: 1e-2 },
    { name: 'Milli', symbol: 'm', factor: 1e-3 },
    { name: 'Micro', symbol: 'µ', factor: 1e-6 },
    { name: 'Nano', symbol: 'n', factor: 1e-9 },
    { name: 'Pico', symbol: 'p', factor: 1e-12 },
    { name: 'Femto', symbol: 'f', factor: 1e-15 },
    { name: 'Atto', symbol: 'a', factor: 1e-18 },
    { name: 'Zepto', symbol: 'z', factor: 1e-21 },
    { name: 'Yocto', symbol: 'y', factor: 1e-24 }
  ]
};
